export const FETCH_INTEGRATION_DASHBOARD = "FETCH_INTEGRATION_DASHBOARD";
export const FETCH_INTEGRATION_DASHBOARD_SUCCESS =
  "FETCH_INTEGRATION_DASHBOARD_SUCCESS";
export const FETCH_INTEGRATION_DASHBOARD_FAILED =
  "FETCH_INTEGRATION_DASHBOARD_FAILED";

export const DOWNLOAD_INTEGRATION_DASHBOARD = "DOWNLOAD_INTEGRATION_DASHBOARD";
export const DOWNLOAD_INTEGRATION_DASHBOARD_SUCCESS =
  "DOWNLOAD_INTEGRATION_DASHBOARD_SUCCESS";
export const DOWNLOAD_INTEGRATION_DASHBOARD_FAILED =
  "DOWNLOAD_INTEGRATION_DASHBOARD_FAILED";

export const FETCH_INTEGRATION_DASHBOARD_SUMMARY =
  "FETCH_INTEGRATION_DASHBOARD_SUMMARY";
export const FETCH_INTEGRATION_DASHBOARD_SUMMARY_SUCCESS =
  "FETCH_INTEGRATION_DASHBOARD_SUMMARY_SUCCESS";
export const FETCH_INTEGRATION_DASHBOARD_SUMMARY_FAILED =
  "FETCH_INTEGRATION_DASHBOARD_SUMMARY_FAILED";
